/**
 * Role-aware home path for the current user — SuperAdmin outside merchant
 * mode goes to the admin area, everyone else to the merchant list.
 */
import { useModel } from '@umijs/max';
import { getActingAsMerchantOwner } from '@/models/actingAsMerchant';
import { getRoleHomePath } from '@/utils/navigation';

export function useRoleHomePath(): string {
  const { initialState } = useModel('@@initialState');
  const role =
    initialState?.currentUser?.role || initialState?.currentUser?.access;
  return getRoleHomePath(role, !!getActingAsMerchantOwner());
}
